import { IResponsiveSettings, IEnabler } from '../interfaces/IProdcat';
import { ComponentTypes } from '../constants/ComponentTypes';
import { deepMerge } from './ObjectUtils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeConfigs = (stateConfig: any, propsConfig: any, overrides: any = {}) => {
    const { prodcatConfig = {}, features, ...restOfStateConfig } = stateConfig;
    const { features: featuresFromProps, ...restOfPropsConfig } = propsConfig;
    const { features: featuresFromState = {}, ...restOfProdcatConfig } = prodcatConfig;

    const configFeatures = deepMerge({}, features, featuresFromState, featuresFromProps);

    return {
        ...restOfProdcatConfig,
        ...restOfStateConfig,
        ...restOfPropsConfig,
        features: {
            ...configFeatures
        },
        ...overrides
    };
};

export const mergeConfigsFor =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (componentType: string) => (stateConfig: any, propsConfig: any, overrides: any = {}) => {
        return mergeConfigs(stateConfig, propsConfig, {
            ...overrides,
            componentType
        });
    };

type CTA_CONFIG = {
    selectedSku?: {
        skuId: string;
    };
    skuId: string;
};

export const mergeProductCTAConfigs = (stateConfig: CTA_CONFIG, propsConfig: CTA_CONFIG) => {
    const config = {
        ...stateConfig,
        ...propsConfig
    };

    const { selectedSku, skuId } = config;

    return {
        ...config,
        skuId: skuId || (selectedSku && selectedSku.skuId)
    };
};

export const getResponsiveConfig = (
    breakpoint: number,
    responsiveSettings?: IResponsiveSettings[]
) => {
    const responsiveConfig =
        responsiveSettings &&
        responsiveSettings.find((responsive) => responsive.breakpoint === breakpoint);

    return responsiveConfig && responsiveConfig.settings;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getConfigOverrides = (config: any = {}, componentType?: ComponentTypes) => {
    const { overrides, ...rootConfig } = config;

    const configOverrides = overrides && componentType && overrides[componentType];

    return { ...rootConfig, ...configOverrides };
};

export const isEnabled = (configKey?: IEnabler): boolean => {
    return Boolean(configKey && configKey.enabled);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeComponentConfigs = <T>(props: any): T => {
    return {
        ...(props.config || {}),
        ...(props.componentConfig || {})
    };
};
